import { searchContent } from '@plone/volto/actions';
import { FormattedDate, Pagination, PreviewImage, UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Card, Container, Grid, Segment } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';

export default function PublicationsView(props) {

  const dispatch = useDispatch();
  const publications = useSelector((state) => state.search.subrequests.publications?.items);
  const total = useSelector((state) => state.search.subrequests.publications?.total);
  const [pageSize, setPageSize] = useState(12);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const contentFilter = {
      b_size: pageSize,
      b_start: currentPage * pageSize,
      portal_type: 'Publication',
      review_state: 'published',
      sort_on: 'publicationtype_date',
      sort_order: 'descending',
      metadata_fields: ['publicationtype_date']
    }
    dispatch(
      searchContent(
        flattenToAppURL(props.content['@id']),
        contentFilter,
        'publications'
      ),
    )
  }, [dispatch, currentPage, pageSize,])

  const onChangePage = (event) => {
    event.preventDefault();
    setCurrentPage(parseInt(event.target.text) - 1);
  };
  const onChangePageSize = (event) => {
    event.preventDefault();
    setPageSize(parseInt(event.target.text));
    setCurrentPage(0);
  };

  return (
    <>
      <Container id="content-core" className="blogView__page pt-5">
        {
          publications && (
            <Grid columns={12} as="ul" className='list-unstyled'>
              {publications.map((item, index) => (
                <Grid.Column key={index} mobile={12} tablet={6} computer={6} widescreen={4} as="li" className='position-relative'>
                  <Card
                    as="article"
                    fluid
                    className={
                      'blogItem ' +
                      (item.image_field ? 'blogItem-hasImage' : 'blogItem-noImage')
                    }
                  >
                    {item.image_field && (
                      <PreviewImage
                        item={item}
                        alt=''
                        className="blogItem__img w-100"
                        responsive={true}
                        sizes="(min-width: 1600px) 500px, (min-width: 1280px) 400px, (min-width: 600px) 200px, 33vw"
                        loading="lazy"
                      />
                    )}
                    <Card.Content className="blogItem__text">
                      <Card.Header as="h3" className="blogItem__title">
                        <UniversalLink
                          href={`${flattenToAppURL(item['@id'])}/@@display-file/publication_document`}
                          className="blogItem__link stretched-link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="blogItem__link__text">{item.title}</span>
                        </UniversalLink>
                      </Card.Header>
                      {item.description &&
                        <Card.Description as="p" className="blogItem__desc">{item.description}</Card.Description>
                      }
                      <Card.Meta className=" newsItem__date">
                        <FontAwesomeIcon className='calendarItem__icon me-2' icon={faCalendarDays} />
                        <FormattedDate date={item.publicationtype_date} as="time" dateTime={item.publicationtype_date}
                          format={{
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }}
                        />
                      </Card.Meta>
                    </Card.Content>
                  </Card>
                </Grid.Column>
              ))}
            </Grid>
          )
        }
        {total > pageSize && (
          <nav className="pagination d-print-none">
            <Pagination
              current={currentPage}
              total={Math.ceil(total / pageSize)}
              onChangePage={onChangePage}
              onChangePageSize={onChangePageSize}
            />
          </nav>
        )}
      </Container>
    </>
  )
}
